import { render, staticRenderFns } from "./fcm.vue?vue&type=template&id=a51a127a&scoped=true"
import script from "./fcm.vue?vue&type=script&lang=js"
export * from "./fcm.vue?vue&type=script&lang=js"
import style0 from "./fcm.vue?vue&type=style&index=0&id=a51a127a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51a127a",
  null
  
)

export default component.exports